import { defineAbility } from '@casl/ability';
import { ABILITY_TYPES, TITLES, URLS } from 'components/common/constants';

export default defineAbility((can, cannot) => {
  can(ABILITY_TYPES.read, TITLES[`${URLS.profile}`]);
  can(ABILITY_TYPES.update, TITLES[`${URLS.profile}`]);
  cannot(ABILITY_TYPES.delete, TITLES[`${URLS.profile}`]);
});
